import { createFileRoute } from "@tanstack/react-router";
import CityPage from "@/pages/CityPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/cars/city/$city/")({
  head: ({ params }) => routeHead("/cars/city/$city/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CityPage />
  );
}
